import script from "./PaginationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationContainer.vue?vue&type=style&index=0&id=13fd90e9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fd90e9"]])

export default __exports__